import React from 'react'
import { Breadcrumbs, MetaSeo } from '../../..'
import Button from '../../../atoms/Button/Button'
import MyImage from '../../../atoms/MyImage/MyImage'
import { Navigation, Pagination, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { getAltText } from '../../../../utils/safe'

const NewsDetailTemplate = (props) => {
  const newsContent = props.newsItem

  return (
    <>
      <div className="page">
        <div className="w-container">
          <MetaSeo seo={props.page.seo} />
          <Breadcrumbs breadcrumbs={props.page.breadcrumbs} />
        </div>
        <div className="news_detail_main_container">
          <div className="news_detail_page_header">
            <MyImage
              src={newsContent.main_image?.url}
              alt={getAltText(newsContent.main_image) || newsContent.titolo}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className="news_detail_content">
            <p className="news_detail_content__data">{newsContent.data}</p>
            <h1 className="news_detail_content__titolo">{newsContent.titolo}</h1>
            <div
              className="news_detail_content__description"
              dangerouslySetInnerHTML={{ __html: newsContent.testo }}
            />
            {newsContent.immagini?.length > 0 && (
              <div className="news_detail_content__slider">
                <div className="swiper--with-pagination">
                  <Swiper 
                    modules={[A11y, Pagination, Navigation]}
                    navigation={true} 
                    pagination={{ clickable: true }} 
                    spaceBetween={50} 
                    slidesPerView={1}
                  >
                    {newsContent.immagini.map((obj, k) => {
                      return (
                        <SwiperSlide key={k}>
                          <div className="news_detail_content__slide">
                            <MyImage
                              src={obj.immagine_url}
                              title={newsContent.titolo}
                              layout="fill"
                              objectFit="contain"
                            />
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                </div>
              </div>
            )}
            <div className="news_detail_content__footer">
              {newsContent.news_precedente_url && (
                <Link legacyBehavior href={newsContent.news_precedente_url}>
                  <a
                    href={newsContent.news_precedente_url}
                    className="news__content__link news_detail_content__prev"
                  >
                    <Button label="Articolo Precedente" />
                  </a>
                </Link>
              )}

              {newsContent.news_successiva_url && (
                <Link legacyBehavior href={newsContent.news_successiva_url}>
                  <a
                    href={newsContent.news_successiva_url}
                    className="news__content__link news_detail_content__next"
                  >
                    <Button label="Articolo successivo" />
                  </a>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default NewsDetailTemplate
